import {
    APP_INITIALIZER,
    effect,
    importProvidersFrom,
    inject,
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TRANSLATION_SETTINGS } from '@de-care/shared/configuration-tokens-locales';
import { TitleStrategy } from '@angular/router';
import { TranslateServiceTitleStrategy } from './translate-service-title-strategy.service';
import { HtmlLang } from '@sxm-util/angular/platform-browser';

export function provideLocaleLegacy({
    locale,
}: {
    locale: {
        languages: {
            supported: ('en-CA' | 'en-US' | 'fr-CA')[];
            default: 'en-CA' | 'en-US' | 'fr-CA';
        };
    };
}) {
    return [
        importProvidersFrom(TranslateModule.forRoot()),
        {
            provide: APP_INITIALIZER,
            useFactory: () => {
                const translateService = inject(TranslateService);
                const translationSettings = inject(TRANSLATION_SETTINGS);
                const htmlLang = inject(HtmlLang);
                effect(() => {
                    translateService.use(htmlLang.currentLang());
                });
                return () => {
                    translationSettings.canToggleLanguage =
                        locale.languages.default !== 'en-US';
                    translationSettings.defaultLanguage =
                        locale.languages.default;
                    translationSettings.languagesSupported =
                        locale.languages.supported;

                    translateService.addLangs(locale.languages.supported);
                    translateService.setDefaultLang(locale.languages.default);
                    translateService.use(locale.languages.default);
                };
            },
            multi: true,
        },
        {
            provide: TitleStrategy,
            useClass: TranslateServiceTitleStrategy,
        },
    ];
}
